/**
 * Bilplatsavtal · Version 2026 (Formulär R-05) — IR twin of the legacy
 * `bilplats@v1` template: upplåtelse av mark för bilplats, fifteen
 * §-numbered sections in source order.
 */
import { applyDefaults, COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { BILPLATS_BLOCKS } from '../bilplats/blocks.js';
const TITLE = 'Bilplatsavtal · Version 2026';
const FORM_NUMBER = 'Formulär R-05';
const SLOTS = BILPLATS_BLOCKS.flatMap((b) => b.slots);
const PREAMBLE = 'Mellan upplåtare och nyttjanderättshavare har följande avtal om upplåtelse av mark för bilplats ingåtts.';
export const bilplatsV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'bilplats',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        numberStyle: 'paragraph',
        category: 'Bilplats',
        shortTitle: 'Bilplatsavtal',
        formNumber: FORM_NUMBER,
        preamble: PREAMBLE,
        status: 'active',
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        titleSuffix: { key: 'bilplats_number', prefix: 'plats' },
        partySlots: [
            { id: 'lessor', label: 'Upplåtare', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'user', label: 'Nyttjanderättshavare', role: 'lessee', ordinal: 0, required: true, signs: true },
        ],
    },
    values: applyDefaults({ fields: SLOTS }, values),
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'upplatare', blockRef: 'bilplats.upplatare@v1', input: {} },
        { instanceId: 'nyttjanderattshavare', blockRef: 'bilplats.nyttjanderattshavare@v1', input: { beside_previous: true } },
        { instanceId: 'bilplats-lage', blockRef: 'bilplats.lage@v1', input: {} },
        { instanceId: 'anvandning', blockRef: 'bilplats.anvandning@v1', input: {} },
        { instanceId: 'samnyttjande', blockRef: 'bilplats.samnyttjande@v1', input: {} },
        { instanceId: 'elstrom', blockRef: 'bilplats.elstrom@v1', input: {} },
        { instanceId: 'upplatelsetid', blockRef: 'bilplats.upplatelsetid@v1', input: {} },
        { instanceId: 'uppsagning', blockRef: 'bilplats.uppsagning@v1', input: {} },
        { instanceId: 'avgift', blockRef: 'bilplats.avgift@v1', input: {} },
        { instanceId: 'moms', blockRef: 'bilplats.moms@v1', input: {} },
        { instanceId: 'andring-avgift', blockRef: 'bilplats.andring-avgift@v1', input: {} },
        { instanceId: 'betalning', blockRef: 'bilplats.betalning@v1', input: {} },
        { instanceId: 'avtalsvillkor', blockRef: 'bilplats.avtalsvillkor@v1', input: {} },
        { instanceId: 'bilagor', blockRef: 'bilplats.bilagor@v1', input: {} },
        {
            instanceId: 'underskrift',
            blockRef: 'bilplats.underskrift@v1',
            input: {
                ref: 'underskrift',
                title: 'Underskrifter',
                statement: true,
                parties: [
                    { label: 'Upplåtare', role: 'lessor', ordinal: 0 },
                    { label: 'Nyttjanderättshavare', role: 'lessee', ordinal: 0 },
                ],
            },
        },
    ],
});
//# sourceMappingURL=bilplats.js.map